<template>
  <div class="light-ide-container">
    <div class="light-ide-gutter" ref="gutter">
      <div
        v-for="n in lineCount"
        :key="n"
        class="light-ide-line-number"
      >{{ n }}</div>
    </div>
    <textarea
      ref="textarea"
      class="light-ide-textarea"
      :value="modelValue"
      @input="onInput"
      @scroll="syncScroll"
    ></textarea>
  </div>
</template>
<script setup>
import { defineProps, defineEmits, ref, computed, watch, nextTick } from 'vue'
const props = defineProps({ modelValue: { type: String, default: '' } })
const emit = defineEmits(['update:modelValue'])
const textarea = ref(null)
const gutter = ref(null)
const lineCount = computed(() => {
  if (props.modelValue === undefined) {
    return []
  }
  if (props.modelValue === null) {
    return []
  }
  const lines = props.modelValue.split('\n')
  const count = lines.length + 1
  return Array.from({ length: count }, (_v, i) => i + 1)
})
function onInput(event) {
  const value = event.target.value
  emit('update:modelValue', value)
}
function syncScroll() {
  if (textarea.value === undefined) {
    return
  }
  if (textarea.value === null) {
    return
  }
  if (gutter.value !== undefined) {
    if (gutter.value !== null) {
      gutter.value.scrollTop = textarea.value.scrollTop
    }
  }
}
watch(
  () => props.modelValue,
  () => {
    nextTick(() => {
      syncScroll()
    })
  }
)
</script>
<style scoped>
.light-ide-container {
  display: flex;
  background-color: #1e1e1e;
  border: 1px solid #333333;
  border-radius: 4px;
  height: 400px;
  width: 100%;
  font-family: Consolas, 'Courier New', monospace;
  color: #d4d4d4;
}
.light-ide-gutter {
  background-color: #2d2d2d;
  padding: 8px 4px;
  text-align: right;
  user-select: none;
  overflow-y: auto;
  width: 50px;
}
.light-ide-line-number {
  padding: 0 6px;
  line-height: 1.5;
  color: #858585;
}
.light-ide-textarea {
  flex: 1;
  background-color: #1e1e1e;
  color: #d4d4d4;
  padding: 8px;
  border: none;
  outline: none;
  resize: none;
  font-family: Consolas, 'Courier New', monospace;
  font-size: 14px;
  line-height: 1.5;
  height: 100%;
  overflow: auto;
  caret-color: #aeafad;
}
.light-ide-textarea::selection {
  background-color: #264f78;
}
.light-ide-container::-webkit-scrollbar, .light-ide-textarea::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
.light-ide-container::-webkit-scrollbar-track, .light-ide-textarea::-webkit-scrollbar-track {
  background: #1e1e1e;
}
.light-ide-container::-webkit-scrollbar-thumb, .light-ide-textarea::-webkit-scrollbar-thumb {
  background: #444444;
  border-radius: 4px;
}
</style>
